<template>
  <div>
    <v-row justify="space-between" align="center" class="legendHead mx-0">
      <h2>{{ stateKey }}es</h2>
      <div @click="addressDetail = !addressDetail">
        <v-icon color="#58e2c2" size="25" v-if="!addressDetail">add</v-icon>
        <v-icon class="icon-top" color="#58e2c2" size="25" v-if="addressDetail">
          maximize
        </v-icon>
      </div>
    </v-row>
    <v-row>
      <v-col px-0 py-0 class="orgDataTables" v-if="addressDetail">
        <v-row class="mt-2">
          <v-col sm="6">
            <TableRecordDisplay
              @recordsSelected="updateTableRowCount($event)"
              :defaultSelected="pageSize"
              :list="countList"
            />
          </v-col>
          <v-spacer></v-spacer>
          <v-col sm="4" class="pt-0 mt-0">
            <v-text-field
              class="search-text pt-2"
              v-model="searchInput"
              placeholder="Search"
              clearable
              @click:clear="clearSearch"
              @keyup="searchFunction(1)"
            >
              <v-icon
                slot="append"
                color="#58E2C2"
                v-if="searchInput === '' || searchInput === null"
                >search</v-icon
              >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div class="actionTables">
              <table class="vgt-table" cellspacing="0">
                <thead>
                  <tr>
                    <th class="text-left">Address</th>
                    <th v-if="stateKey === 'Outgoing Address'" align="start">
                      Priority
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in preferenceServiceHelper.filterPreference(
                      rowsData
                    )"
                    :key="item.id"
                  >
                    <td>{{ item.data.ipOrDomain[stateKey].value }}</td>
                    <td v-if="stateKey === 'Outgoing Address'">
                      {{ titleCase(item.data.ipOrDomain[stateKey].priority) }}
                    </td>
                    <td align="end">
                      <v-btn
                        class="white--text filled-btn"
                        tile
                        elevation="0"
                        color="#FF4F4F"
                        @click="openConfirmBox(item)"
                        >Remove</v-btn
                      >
                    </td>
                  </tr>
                  <tr
                    v-if="
                      preferenceServiceHelper.filterPreference(rowsData)
                        .length === 0
                    "
                  >
                    <td v-if="loading" colspan="3" class="text-center">
                      <TableLoader :loading="loading" />
                    </td>
                    <td v-if="!loading" colspan="3" class="text-center">
                      No records
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <Pagination
              v-if="totalRecords >= pageSize"
              :pageNumber="pageNumber"
              :totalRecords="totalRecords"
              :recordsPerPage="pageSize"
              @pageChanged="setPage($event)"
            />
          </v-col>
        </v-row>
        <AddIPAddress
          :addHead="addHead + stateKey"
          @dataSubmit="addIpAddress"
          :clear="addClear"
          v-if="stateKey === 'Incoming Address'"
        />
        <AddIPWithCategory
          :addHead="addHead + stateKey"
          @dataSubmit="addIpAddress"
          :option="option"
          :clear="addClear"
          :selectedType="selectedCategory"
          v-else
        /> </v-col
    ></v-row>
    <x-dialog
      :dialogState="confirmDialogueVar"
      :dialogTitle="dialogTitle"
      :confirmDialog="true"
      :dialogText="dialogText"
      :actions="{
        show: true,
        secondaryButtonFunction: closeConfirmBox,
        primaryButtonFunction: removeIp,
        primaryButtonShow: true,
        secondaryButtonText: cancelText,
        primaryButtonText: successText,
      }"
      @toggleModal="closeConfirmBox"
    ></x-dialog>
  </div>
</template>

<script>
const debounceTimeInMilliseconds = 800;
import TableLoader from '@/components/Common/TableLoader.vue';
import Pagination from '@/components/Discovery/Widgets/Pagination';
import TableRecordDisplay from '@/components/Common/TableRecordDisplaySelector';
import AddIPAddress from '@/components/Organisations/Domains/Domain/AddIpAddress';
import AddIPWithCategory from '@/components/Organisations/Domains/Domain/AddIpWithCategory';
import PreferencesService from '@/services/PreferencesService';
import PreferenceHelper from '@/helpers/PreferenceHelper';
let debounce = require('lodash.debounce');
export default {
  props: {
    domainKey: {
      type: String,
      default: '',
    },
    stateKey: {
      type: String,
      default: '',
    },
  },
  components: {
    TableLoader,
    Pagination,
    TableRecordDisplay,
    AddIPAddress,
    AddIPWithCategory,
  },
  data() {
    return {
      addressDetail: true,
      pageSize: 5,
      searchInput: '',
      selectedItems: [],
      countList: [
        {
          val: 5,
          label: '5 entries',
        },
        {
          val: 10,
          label: '10 entries',
        },
        {
          val: 15,
          label: '15 entries',
        },
        {
          val: 20,
          label: '20 entries',
        },
      ],
      totalRecords: 0,
      pageNumber: 1,
      selectAll: false,
      loading: false,
      rowsData: [],
      addHead: 'Add an ',
      preferenceServiceHelper: null,
      option: [
        { key: '', value: 'Select' },
        { key: 'primary', value: 'Primary' },
        { key: 'secondary', value: 'Secondary' },
      ],
      selectedCategory: '',
      addClear: false,
      removeItemObj: null,
      confirmDialogueVar: false,
      dialogTitle: '',
      dialogText: '',
      cancelText: '',
      successText: '',
    };
  },
  methods: {
    async getAddresses(initial) {
      if (initial) {
        this.pageNumber = 1;
        this.totalRecords = 0;
        this.pageSize = 5;
      }
      let paging = {
        pageable: true,
        pageNumber: this.pageNumber,
        size: this.pageSize,
      };
      this.rowsData = [];
      this.loading = true;
      try {
        let response = await PreferencesService.getPreferencesByPreferenceKey(
          this.domainKey,
          paging,
          this.$route.params.domainId
        );
        this.updateListData(response);
        this.loading = false;
      } catch (err) {
        this.loading = false;
        if (
          err.response.data.errors[0].message === this.$message.NOT_AUTHORIZED
        ) {
          this.$router.push({
            path: 'domains',
          });
        }
        this.snackbar('error', err);
      }
    },
    updateListData(listResponse) {
      let response = this.parseResponse(listResponse);
      if (response !== false) {
        this.totalRecords = response[0].totalResults;
        this.rowsData = response[0].results;
      } else {
        this.snackbar('error', this.$message.CANNOT_LOAD_SETTING_DATA);
      }
      this.loading = false;
    },
    updateTableRowCount(val) {
      this.pageSize = val;
      this.setPage(1);
    },
    setPage(page) {
      this.pageNumber = page;
      if (!this.searchInput || this.searchInput === '') {
        this.getAddresses();
      } else {
        this.searchItem(this.pageNumber);
      }
    },
    clearSearch() {
      this.searchInput = '';
      this.pageNumber = 1;
      this.totalRecords = 0;
      this.getAddresses(false);
    },
    searchFunction: debounce(function (pageNumber) {
      if (this.searchInput === null) {
        this.searchInput = '';
      }
      if (this.searchInput === '') {
        this.pageNumber = 1;
        this.totalRecords = 0;
        this.getAddresses(false);
      } else {
        this.searchItem(pageNumber);
      }
    }, debounceTimeInMilliseconds),
    async searchItem(pageNumber) {
      //search email list function
      let paging = {
        pageable: true,
        pageNumber: pageNumber,
        size: this.pageSize,
      };
      this.pageNumber = pageNumber;
      this.rowsData = [];
      if (pageNumber === 1) {
        this.totalRecords = 0;
      }
      this.loading = true;
      try {
        let response = await PreferencesService.searchPreferences(
          this.domainKey,
          this.searchInput,
          paging,
          this.$route.params.domainId
        );
        this.updateListData(response);
      } catch (err) {
        this.loading = false;
        this.snackbar('error', err);
      }
    },
    async addIpAddress(val) {
      let reqObject = {};
      if (this.stateKey === 'Incoming Address') {
        reqObject = this.preferenceServiceHelper.createPreferenceBody(
          'ipOrDomain',
          { value: val },
          this.stateKey
        );
      } else {
        reqObject = this.preferenceServiceHelper.createPreferenceBody(
          'ipOrDomain',
          { value: val.ipAddress, priority: val.category },
          this.stateKey
        );
      }
      this.addClear = false;
      try {
        await PreferencesService.addPreference(
          this.domainKey,
          reqObject,
          null,
          null,
          this.$route.params.domainId
        );
        this.getAddresses(false);
        this.addClear = true;
        this.snackbar('success', this.$message.IP_ADD_SUCCESS);
      } catch (err) {
        this.addClear = true;
        this.snackbar('error', err);
      }
    },
    async removeIp() {
      try {
        await PreferencesService.removePreference(this.removeItemObj.id);
        if (
          this.rowsData.length === 1 &&
          Math.ceil(this.totalRecords / this.pageSize) === this.pageNumber &&
          this.pageNumber !== 1
        ) {
          this.pageNumber--;
        }
        this.setPage(this.pageNumber);
        this.snackbar('success', this.$message.IP_REMOVED_SUCCESS);
        this.removeItemObj = null;
        this.closeConfirmBox();
      } catch (err) {
        this.snackbar('error', err);
        this.closeConfirmBox();
      }
    },
    openConfirmBox(removeObj) {
      this.dialogTitle = 'Please Confirm';
      this.dialogText = 'Are you sure you want to remove this IP Address?';
      this.cancelText = 'Cancel';
      this.successText = 'Yes';
      this.confirmDialogueVar = true;
      this.removeItemObj = removeObj;
    },
    closeConfirmBox() {
      this.confirmDialogueVar = false;
    },
  },
  created() {
    this.preferenceServiceHelper = new PreferenceHelper();
  },
  mounted() {
    this.getAddresses(true);
  },
};
</script>
